import { RefObject, useEffect, useState } from 'react';


export function useLineCount(typography: RefObject<HTMLSpanElement | null>, text: string | undefined): number {
	const [lineCount, setLineCount] = useState(1);

	useEffect(function measureLineCount() {
		if (typography.current) {
			const lineHeight = parseFloat(getComputedStyle(typography.current).lineHeight);
			const height = typography.current.scrollHeight;
			const lines = Math.round(height / lineHeight);
			setLineCount(lines);
		}
	}, [text]);

	return lineCount;
}